import type { Periodo } from '@praticheenergia/domain'
import { supabase } from '../lib/supabase'
import type { RigaVendita } from './interpreta'

export async function elencaVendite(dichiarazioneId: number): Promise<RigaVendita[]> {
  const { data, error } = await supabase
    .from('vendita')
    .select('mese, provincia, tipologia, numero_utenze, kwh')
    .eq('dichiarazione_id', dichiarazioneId)
    .order('mese')
    .order('provincia')
  if (error) throw new Error(error.message)
  return ((data ?? []) as { mese: number; provincia: string; tipologia: string; numero_utenze: number; kwh: number | string }[]).map(
    (r) => ({ mese: r.mese, provincia: r.provincia, tipologia: r.tipologia, numeroUtenze: r.numero_utenze, kwh: String(r.kwh) }),
  )
}

/** Sostituisce tutte le righe della dichiarazione (0034_vendita.sql). */
export async function salvaVendite(dichiarazioneId: number, righe: readonly RigaVendita[]): Promise<void> {
  const { error } = await supabase.rpc('salva_vendite', { p_dichiarazione_id: dichiarazioneId, p_righe: righe })
  if (error) throw new Error(error.message)
}

/** Le sigle ammesse sono quelle a cui le regole del periodo danno un ambito:
 * la stessa tabella che usa il motore, non l'anagrafica dei comuni. */
export async function provinceDelPeriodo(anno: number, periodo: Periodo): Promise<Set<string>> {
  const { data, error } = await supabase
    .from('regola_fiscale')
    .select('province:contenuto->ambiti->perProvincia')
    .eq('anno_imposta', anno)
    .eq('periodo', periodo)
    .single()
  if (error) throw new Error(error.message)
  return new Set(Object.keys((data as { province: Record<string, number> | null }).province ?? {}))
}
